module.exports = {
      id: "save-usage",
      viewBox: "0 0 21.6 21.6",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#save-usage",
      toString: function () {
        return this.url;
      }
    }